/* eslint-disable import/no-unresolved, import/extensions */

console.log('vooglam.js provider 文件已加载');

export const getImage = (src, { modifiers, providerOptions, baseURL }) => {
  const { width } = modifiers || {};
  // 优先使用 baseURL 参数，其次从 providerOptions 获取，最后使用默认值
  const finalBaseURL = baseURL || providerOptions?.baseURL || 'https://cdn-test-vooglam.xmslol.cn';

  // 如果 src 已经是完整 URL，直接使用；否则拼接 baseURL
  let fullUrl;
  if (src.startsWith('http://') || src.startsWith('https://')) {
    fullUrl = src;
  } else {
    // 确保 baseURL 不以 / 结尾，src 以 / 开头
    const cleanBaseURL = finalBaseURL.replace(/\/$/, '');
    const cleanSrc = src.startsWith('/') ? src : `/${src}`;
    fullUrl = cleanBaseURL + cleanSrc;
  }

  // 构建基础 URL
  const baseUrl = new URL(fullUrl);
  const baseWidth = width || 960;

  // 主图片 URL：在 src 后面添加 im=Resize,width=${width} 参数
  const url = new URL(baseUrl.href);
  const im = url.searchParams.get('im');
  // width 优先，然后akamai函数，最后再有默认width兜底
  if (im && im.includes('Resize,width=') && width) {
    url.searchParams.set('im', `Resize,width=${Math.min(width, 1920)}`);
  } else if (im && !im.includes('Resize,width=')) {
    url.searchParams.set('im', `Resize,width=${Math.min(baseWidth, 1920)}`);
  }
  url.searchParams.set('adaptive', '1');
  return {
    url: url.href,
  };
};

export default getImage;
